<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_item')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('tax_method')}}</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="dataList"
                  :no-data-text="$t('no_data')"
                  :hide-default-footer="true"
                 :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
                  height="400px"
                >
                  <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
                  <template v-slot:item.no="{index}">{{index+1}}</template>
                  <template v-slot:item.dependent="{item}">{{item.dependent == 1? $t('yes') : $t('no')}}</template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('tax_method')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col md="12">
              <v-select
               :label="$t('tax_component')"
                v-model="detail.taxMethodId"
                :rules="[...rules2, validator.alfaNumberNotRequired]"
                :items="componentList"
                item-text="methodName"
                item-value="id"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="6">
              <v-menu
                ref="menu"
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.startDate)"
                   :label="$t('start_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    :rules="rules"
                    required
                    class="sae-required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.startDate"
                  @change="onStartDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="6">
              <v-menu
                ref="menu"
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.endDate)"
                    :label="$t('end_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    clearable
                    @click:clear="clearValue('endDate')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.endDate"
                  @change="onEndDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                  :min="detail.startDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="12">
              <v-text-field :rules="[validator.alfaNumberNotRequired]" label="Notes" v-model="detail.note"></v-text-field>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="tab = 0">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :loading="loading"
                :disabled="!valid"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId'],
  name: "TaxMethod",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('tax_method'), value: "taxMethodName" },
        { text: this.$i18n.t('start_date'), value: "startDate" },
        { text: this.$i18n.t('end_date'), value: "endDate" },
        { text: this.$i18n.t('note'), value: "note" },
        { text: "", value: "action" },
      ],
      tab: 0,
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4: [
        v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      dataList: [],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      detail: {},
      isEdit: false,
      deleteDialog: false,
      componentList: [],
      menuStart: false,
      menuEnd: false,
    }
  },
  methods: {
    clearValue(value) {
      this.detail[value] = null
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({}, item)
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    add() {
      this.isEdit = false
      setTimeout(() => {
        this.detail = { userId: this.userId, startDate: null, endDate: null, }
      }, 50);
      this.tab = 1
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY');
      return null
    },
    onStartDateChange() {
      if (this.detail.endDate) this.detail.endDate = this.detail.startDate
      this.menuStart = false;
    },
    onEndDateChange() {
      this.menuEnd = false;
    },
    async getData(userId) {
      this.loading = true
      const result = await this.$store.dispatch('getTaxMethod', { userId })
      this.loading = false
      return result
    },
    async getComponent() {
      this.loading = true
      const result = await this.$store.dispatch('getTaxMethodComponent')
      this.loading = false
      return result
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('saveTaxMethod', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.refreshData()
        this.tab = 0
      } else {
        this.showMessage('warning', 'Saved Failed')
      }
    },
    async editComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('editTaxMethod', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.refreshData()
        this.tab = 0
      } else {
        this.showMessage('warning', 'Saved Failed')

      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('deleteTaxMethod', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.refreshData()
        this.tab = 0
        this.deleteDialog = false
      } else {
        this.showMessage('warning', 'Delete Failed')
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async refreshData() {
      this.detail = { startDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD'), endDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD') }
      this.dataList = await this.getData(this.userId)
    },
  },
  async created() {
    this.componentList = await this.getComponent()
    this.refreshData()
  },
  watch: {
    dataList() {
      this.formData = this.dataList
      this.tab = 0
      this.detail = { startDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD'), endDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD') }
    },
    userId() {
      this.refreshData()
    },
    detail() {
      if (this.$refs.form && !this.isEdit) {
        this.$refs.form.reset();
      }
    }
  }
}
</script>
<style scoped>
.camelcase {
  text-transform: capitalize !important;
}
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>